// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_2BWOnVmKfsnb0GyS6c6sQh","number":"_20-1d1MW2I_6ZX3MnX9euN","text":"_1ZQpRYCKfSjLV50fPE3gSu"};